__turbopack_context__.v({
  "error": "Form-module__-v2ZHG__error",
  "field": "Form-module__-v2ZHG__field",
  "fields": "Form-module__-v2ZHG__fields",
  "form": "Form-module__-v2ZHG__form",
  "required": "Form-module__-v2ZHG__required",
  "threeFields": "Form-module__-v2ZHG__threeFields",
  "twoFields": "Form-module__-v2ZHG__twoFields",
  "unstackable": "Form-module__-v2ZHG__unstackable",
});
